import React,{useState} from 'react';
import Fade from 'react-reveal/Fade';
import {BsCart2} from 'react-icons/bs';
import {HiOutlineBars3} from 'react-icons/hi2';

import {
    Box,
    Drawer,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
} from '@mui/material';

import HomeIcon from '@mui/icons-material/Home';
import InfoIcon from '@mui/icons-material/Info';
import CommentRoundedIcon from '@mui/icons-material/CommentRounded';
import PhoneRoundedIcon from '@mui/icons-material/PhoneRounded'
import ShoppingCartRoundedIcon from '@mui/icons-material/ShoppingCartRounded';

const Navbar = () => {

    const [openMenu, setOpenMenu] = useState(false)
    const menuOptions = [
        {
            text:"Home",
            icon:<HomeIcon/>
        },
        {
            text:"About",
            icon:<InfoIcon/>
        },
        {
            text:"Testimonials",
            icon:<CommentRoundedIcon/>
        },
        {
            text:"Contact",
            icon:<PhoneRoundedIcon/>
        },
        {
            text:"Cart",
            icon:<ShoppingCartRoundedIcon/>
        },
    ];

  return (
    <nav>
        <Fade top>
      <div className='nav-logo-container'>
        <h1>earthly</h1>
        <h6>Sustainable products at affordable prices</h6></div>
        </Fade>
      <div className='navbar-links-container'>
        <Fade right>
        <a className='nicon' href="">Home</a>
        <a className='nicon' href="">About</a>
        <a className='nicon' href="">Testimonials</a>
        <a className='nicon' href="">Contact</a>
        <a className='nicon' href="">
            <BsCart2 className='navbar-cart-icon'/>
        </a>
        </Fade>
        <Fade right>
        <button className='primary-button'>Shop Now</button>
        </Fade>
        </div>
        <div className='navbar-menu-container'>
             <HiOutlineBars3 onClick={()=> setOpenMenu(true)}/>
        </div>
        <Drawer open={openMenu} onClose={()=> setOpenMenu(false)}
        anchor='right'>
            <Box
                sx={{width:250}}
                role="presentation"
                onClick={() => setOpenMenu(false)}
                onKeyDown={()=> setOpenMenu(false)}
            >
                <List>
                    {menuOptions.map((item)=>(
                        <ListItem key={item.text} disablePadding>
                            <ListItemButton>
                            <ListItemIcon>{item.icon}
                            </ListItemIcon>
                            <ListItemText primary={item.text}/>    
                            </ListItemButton>
                        </ListItem>
                    ))}
                </List>

            </Box> 

        </Drawer>
    </nav>
  )
}

export default Navbar
